import { render, staticRenderFns } from "./InboundSelect.vue?vue&type=template&id=951ec77e&scoped=true&"
import script from "./InboundSelect.vue?vue&type=script&lang=js&"
export * from "./InboundSelect.vue?vue&type=script&lang=js&"
import style0 from "./InboundSelect.vue?vue&type=style&index=0&id=951ec77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951ec77e",
  null
  
)

export default component.exports